import React from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import BlogsDetailsImage from "../assets/images/blog-detail-img.png";
import BlogsDetailsImage1 from "../assets/images/blog-detail-img-1.png";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useBlogDetails } from "../hooks/useBlogDetails";
import { ASSETS_URL } from "../api/constants";
import UserIcon from '../assets/images/user-1.svg';
import CalendarIcon from '../assets/images/calendar.svg';
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'
import { formatDate } from "../utils/date";

function BlogsDetails() {
  const { slug } = useParams();
  const { blog, loading, error } = useBlogDetails(slug);
  const relatedBlogs = [
    {
      id: '01',
      title: "Buyers: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '02',
      title: "Sellers: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '03',
      title: "Fed Cuts Rates, but Powell Says December Cut Is No Guarantee"
    },
    {
      id: '04',
      title: "Renters: Results from the Real Estate Consumer Housing Trends Report 2025"
    },
    {
      id: '05',
      title: "Buyers: Results from the Real Estate Consumer Housing Trends Report 2025"
    }
  ];
  return (
    <>
      <div className="main blog-details-page">
        <Header />
        <section className="blog-details-section common-padding">
          <Container>
            <Row>
              <Col lg={8} md={12}>
                <article className="blog-article">
                  <div className="article-header">
                    <span className="category-badge">{blog?.category_name}</span>
                    <h1 className="article-title">{blog?.title}</h1>
                    <p className="article-subtitle">{blog?.meta_description}</p>
                  </div>
                  <div className="featured-image">
                    <img 
                      src={blog?.imageUrl ? ASSETS_URL + blog.imageUrl : blog?.image ? ASSETS_URL + blog.image : BlogsDetailsImage}
                      alt={blog?.title || 'Blog image'} 
                    />
                  </div>
                  <div className="article-meta">
                    <div className="author-info">
                        <img src={UserIcon} alt="John Doe" />
                      <span className="author-name">{blog?.created_by_first_name} {blog?.created_by_last_name}</span>
                    </div>
                    <div className="author-info">
                        <img src={CalendarIcon} alt="27 Apr 2025" />
                      <span className="author-name">{formatDate(blog?.created_at)}</span>
                    </div>
                    
                    <div className="social-share">
                      <ul>
                        <li>
                          <a href="#" target="_blank">
                            <img src={Facebook} alt="Facebook" />
                          </a>
                        </li> 
                        <li>
                          <a href="#" target="_blank">
                            <img src={X} alt="X" />
                            </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={Instagram} alt="Instagram" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={YouTube} alt="YouTube" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src={LinkedIn} alt="LinkedIn" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Article Content */}
                  <div className="article-content">
                    {loading && <p>Loading blog...</p>}
                    {!loading && error && <p className="text-danger">{error}</p>}
                    {!loading && !error && !blog && <p>No blog found.</p>}

                    {!loading && !error && blog && (
                      <>
                        {blog.description ? (
                          <div dangerouslySetInnerHTML={{ __html: blog.description }} />
                        ) : (
                          <p>No blog content is available.</p>
                        )}


                      </>
                    )}
                  </div>
                </article>
              </Col>

              {/* Sidebar */}
              {blog?.related_blogs && blog.related_blogs.length > 0 && (
              <Col lg={4} md={12}>
                <aside className="blog-sidebar">
                  <h3>Related Blogs</h3>
                  <div className="sidebar-widget">
                    <ul className="related-blogs-list">
                      {blog?.related_blogs.map((related) => (
                        <li key={related.id} className="related-blog-item">
                          <Link to={`/blogs-details/${related?.slug || related.id}`} className="blog-link">
                            <span>{related.id}</span>
                            {related.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </Col>
              )}
            </Row>
          </Container>
        </section>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default BlogsDetails;
